(function () {
  if (window.__sawayScrollRestoreInit) return;
  window.__sawayScrollRestoreInit = true;

  var POS_KEY = 'saway-pos';
  var MARKER_KEY = 'saway-back-marker';
  var MARKER_TTL = 30 * 60 * 1000;
  var MAX_POS_ENTRIES = 20;

  // Volatile params (Shopify preview bar, ad-tracking) come and go between
  // visits to the same page; strip them so position/marker keys still match.
  var VOLATILE_PARAM = /^(pb|swdebug|preview_theme_id|_ab|_fd|_sc|key|fbclid|gclid|utm_.*)$/;
  function urlKey(pathname, search) {
    var kept = [];
    if (search && search.length > 1) {
      var parts = search.slice(1).split('&');
      for (var i = 0; i < parts.length; i++) {
        var name = decodeURIComponent(parts[i].split('=')[0] || '');
        if (!VOLATILE_PARAM.test(name)) kept.push(parts[i]);
      }
    }
    return pathname + (kept.length ? '?' + kept.join('&') : '');
  }

  var cur = urlKey(location.pathname, location.search);

  function isProductPath(path) {
    return path.indexOf('/products/') !== -1;
  }

  function referrerKey() {
    try {
      if (!document.referrer) return null;
      var u = new URL(document.referrer);
      if (u.origin !== location.origin) return null;
      return urlKey(u.pathname, u.search);
    } catch (e) {
      return null;
    }
  }

  function readJSON(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key)) || null;
    } catch (e) {
      return null;
    }
  }
  function writeJSON(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  // Positions are stored per URL: { "<path+search>": [scrollY, timestamp] },
  // pruned to the most recent MAX_POS_ENTRIES.
  function savePosition() {
    var map = readJSON(POS_KEY) || {};
    map[cur] = [Math.round(window.scrollY), Date.now()];
    var keys = Object.keys(map);
    if (keys.length > MAX_POS_ENTRIES) {
      keys.sort(function (a, b) {
        return map[a][1] - map[b][1];
      });
      for (var i = 0; i < keys.length - MAX_POS_ENTRIES; i++) delete map[keys[i]];
    }
    writeJSON(POS_KEY, map);
  }

  function savedPosition() {
    var map = readJSON(POS_KEY);
    var hit = map && map[cur];
    return hit ? parseInt(hit[0], 10) : NaN;
  }

  window.addEventListener('pagehide', savePosition);
  var scrollTimer = null;
  window.addEventListener(
    'scroll',
    function () {
      if (scrollTimer) return;
      scrollTimer = setTimeout(function () {
        scrollTimer = null;
        savePosition();
        restamp();
      }, 250);
    },
    { passive: true }
  );

  // --- return-detection signal 1: history.state stamp ------------------
  // Reliable on desktop; iOS Chrome loses history.state on back-navigation
  // reloads, and theme code (filters/variant sync) occasionally rewrites
  // state, hence restamp() re-asserts it after load and on scroll.
  var entryId = null;
  var stampReturning = false;
  try {
    var state = history.state || {};
    if (state.sawayScrollId) {
      entryId = state.sawayScrollId;
      stampReturning = true;
    } else {
      entryId =
        Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      state.sawayScrollId = entryId;
      history.replaceState(state, '');
    }
  } catch (e) {}

  function restamp() {
    try {
      var st = history.state || {};
      if (st.sawayScrollId !== entryId) {
        st.sawayScrollId = entryId;
        history.replaceState(st, '');
      }
    } catch (e) {}
  }

  // --- return-detection signal 2: navigation type ----------------------
  // iOS WebKit misreports back/forward as "navigate", so this only helps
  // browsers with a working Navigation Timing implementation.
  var navType = '';
  try {
    var navEntries = performance.getEntriesByType
      ? performance.getEntriesByType('navigation')
      : [];
    navType = navEntries.length ? navEntries[0].type : '';
    if (!navType && performance.navigation) {
      navType = performance.navigation.type === 2 ? 'back_forward' : '';
    }
  } catch (e) {}

  // --- return-detection signal 3: product-visit handshake --------------
  // History-API-free, so it survives iOS Chrome. Opening a product page
  // records which listing it was opened from. When that listing URL loads
  // again and the referrer is NOT a product page (a fresh click from a
  // product page would carry its URL as referrer; a back-navigation reload
  // replays the listing's original referrer), it is a return.
  var refKey = referrerKey();
  var markerReturning = false;
  if (isProductPath(location.pathname)) {
    if (refKey && !isProductPath(refKey) && refKey !== cur) {
      writeJSON(MARKER_KEY, { url: refKey, ts: Date.now() });
    }
  } else {
    var marker = readJSON(MARKER_KEY);
    if (marker && marker.url === cur) {
      try {
        sessionStorage.removeItem(MARKER_KEY);
      } catch (e) {}
      if (Date.now() - marker.ts < MARKER_TTL && !(refKey && isProductPath(refKey))) {
        markerReturning = true;
      }
    }
  }

  var target = savedPosition();

  function restore() {
    // Take ownership: the browser's own (late, async) restoration would
    // otherwise fight ours and cause a visible double-jump.
    try {
      history.scrollRestoration = 'manual';
    } catch (e) {}

    // Runs at script evaluation (defer = DOM parsed, before images load).
    // Grid images reserve their height via aspect-ratio, so the page is
    // usually already tall enough to land exactly, with no visible jump.
    // Retry while the page grows; stop the moment the user genuinely
    // scrolls (touchmove/wheel — a mere tap must not cancel).
    var start = Date.now();
    var userScrolled = false;
    function markUserScroll() {
      userScrolled = true;
    }
    window.addEventListener('touchmove', markUserScroll, {
      passive: true,
      once: true,
    });
    window.addEventListener('wheel', markUserScroll, {
      passive: true,
      once: true,
    });

    (function attempt() {
      if (userScrolled) return;
      var maxY = document.documentElement.scrollHeight - window.innerHeight;
      if (maxY >= target) {
        window.scrollTo(0, target);
        return;
      }
      if (Date.now() - start < 5000) {
        requestAnimationFrame(attempt);
      } else if (maxY > 0) {
        window.scrollTo(0, Math.min(target, maxY));
      }
    })();
  }

  if (
    !location.hash &&
    isFinite(target) &&
    target > 0 &&
    (stampReturning || navType === 'back_forward' || markerReturning)
  ) {
    restore();
  }

  // bfcache rescue: iOS Chrome serves the page from the back/forward cache
  // (pageshow persisted=true) but resets the scroll position to 0 instead of
  // preserving it. Scripts don't re-run on bfcache restores, so this handler
  // is the only hook. Only act when the browser clearly lost the position
  // (we're at ~top while the recorded position is well below) — browsers
  // that restore correctly are left alone.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var saved = savedPosition();
    if (!isFinite(saved) || saved < 100) return;

    var cancelled = false;
    function cancel() {
      cancelled = true;
    }
    window.addEventListener('touchmove', cancel, { passive: true, once: true });
    window.addEventListener('wheel', cancel, { passive: true, once: true });

    // WebKit may zero the scroll asynchronously shortly after pageshow, so
    // enforce over a brief window rather than once.
    var deadline = Date.now() + 600;
    (function enforce() {
      if (cancelled) return;
      if (window.scrollY < 100 && Math.abs(window.scrollY - saved) > 100) {
        window.scrollTo(0, saved);
      }
      if (Date.now() < deadline) requestAnimationFrame(enforce);
    })();
  });
})();
